import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useProgrammes = (params = {}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params);
  useEffect(() => {
    setLoading(true);
    api.get("/programmes", { params: JSON.parse(key) })
      .then((r) => setData(r.data))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [key]);
  return { data, loading };
};
